import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AcceptInvite from './pages/AcceptInvite';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check URL for deep-linking: keg IDs, tap lists, and invite acceptance
const path = window.location.pathname;
const kegIdMatch = path.match(/\/k\/([a-f0-9-]+)/i);
const tapMatch = path.match(/\/taps\/([^/]+)(?:\/([^/]+))?/i);
const inviteMatch = path.match(/\/accept-invite/i);

// If on accept-invite path, render AcceptInvite page
if (inviteMatch) {
  root.render(
    <React.StrictMode>
      <AcceptInvite />
    </React.StrictMode>
  );
} else {
  // Otherwise render main App with deep-linking support
  root.render(
    <React.StrictMode>
      <App
        initialKegId={kegIdMatch ? kegIdMatch[1] : null}
        initialTapLocation={tapMatch ? decodeURIComponent(tapMatch[1]) : null}
        initialTapSublocation={tapMatch && tapMatch[2] ? decodeURIComponent(tapMatch[2]) : null}
      />
    </React.StrictMode>
  );
}